import { Routes } from '@angular/router';
import { authGuard } from './shared/auth/auth-guard.service';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { NoContentComponent } from './no-content';
import { massiveActionsGuard } from './massive-actions/shared/massive-actions.guard';
import { historyGuard } from './history/history.guard';
import { officeGuard } from './office/office.guard';
import { tpaGuard } from './tpa/tpa.guard';

export const ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [authGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'unauthorized', component: LoginComponent },
  { path: 'unauthorized/:returnUrl', component: LoginComponent },
  {
    path: 'office',
    loadChildren: () => import('./office/office.module').then(m => m.OfficeModule),
    canActivate: [authGuard, officeGuard],
  },
  { path: 'tpa', loadChildren: () => import('./tpa/tpa.module').then(m => m.TpaModule), canActivate: [authGuard, tpaGuard] },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    canActivate: [authGuard],
  },
  {
    path: 'history',
    loadChildren: () => import('./history/history.module').then(m => m.HistoryModule),
    canActivate: [authGuard, historyGuard],
  },
  {
    path: 'massive-actions',
    loadChildren: () => import('./massive-actions/massive-actions.module').then(m => m.MassiveActionModule),
    canActivate: [authGuard, massiveActionsGuard],
  },
  { path: '**', component: NoContentComponent },
];
